import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getBaseUrl } from '@/config/config';
import RouteSwitch from './routes';
import { setorientation } from './redux/index/action';
import '@/scss/common.scss';

function App(): JSX.Element {
    const dispatch = useDispatch();
    useEffect(() => {
        Object.defineProperty(window.lib.flexible, 'orientation', {
            get() {
                // eslint-disable-next-line react/no-this-in-sfc
                return this._value;
            },
            set(value) {
                // eslint-disable-next-line react/no-this-in-sfc
                this._value = value;
                dispatch(setorientation(value));
            }
        });
    }, []);
    return (
        <BrowserRouter basename={getBaseUrl()}>
            <RouteSwitch />
        </BrowserRouter>
    );
}

export default App;
